import CardLink from './modules/card-link';
import Carousel from './modules/carousel';
import EventsFilter from './modules/events-filter';
import Expandable from './modules/expandable';
import FormRequiredFields from './modules/form-required-fields';
import Increment from './modules/increment';
import Modal from './modules/modal';
import SiteHeader from "./modules/site-header";
import Ticket from './modules/ticket';

document.addEventListener("DOMContentLoaded", function(event) {

  new SiteHeader();

  const cardLinks = document.querySelectorAll('[data-js-card-link]');
  [...cardLinks].forEach(cardLink => new CardLink(cardLink));

  const carousels = document.querySelectorAll('.carousel');
  [...carousels].forEach(carousel => new Carousel(carousel));

  const expandables = document.querySelectorAll('[data-js-expandable]');
  [...expandables].forEach(expandable => new Expandable(expandable));

  const modals = document.querySelectorAll('[data-js-modal]');
  [...modals].forEach(modal => new Modal(modal));

  const requiredField = document.querySelector('[required]');
  if (requiredField) {
    const form = requiredField.closest('form');
    new FormRequiredFields(form);
  }
  

  // Only 1 on a page.
  const eventsFilter = document.querySelector('.events-filter');
  if (eventsFilter) {
    new EventsFilter(eventsFilter);
  }

  const tickets = document.querySelectorAll('.ticket');
  [...tickets].forEach(ticket => new Ticket(ticket));

  const increments = document.querySelectorAll('[data-js-increment]');
  [...increments].forEach(increment => new Increment(increment));

  
  // Add expandable functionality to content within modals.
  document.body.addEventListener('modalOpen', e => {

    // Trap keyboard navigation focus tabbing inside modal content.
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const modal = document.querySelector('.modal.open');
    const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
    const focusableContent = modal.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1];

    document.addEventListener('keydown', function(e) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    });

    firstFocusableElement.focus();

    const modalExpandables = document.querySelectorAll('.alertModal [data-js-expandable]');
    [...modalExpandables].forEach(expandable => new Expandable(expandable));
  });


  document.documentElement.classList.remove('no-js');
});